export const ParticipantOrder = {
  AMERICAN: 'AMERICAN',
  WORLD: 'WORLD',
}

export const gridModes = {
  BETTING_OPTIONS: 'BETTING_OPTIONS',
  PARTICIPANTS: 'PARTICIPANTS',
}

export const marketTypesFormat = {
  DEFAULT: 'DEFAULT',
  HANDICAP: 'HANDICAP',
  TOTALS: 'TOTALS',
  DRAW: 'DRAW',
}

export const marketTypes = {
  MONEYLINE: 401,
  POINTSPREAD: 403,
  TOTALS: 407,
}

export const showLiveTypes = {
  ONLY_LIVE_EVENTS: 'ONLY_LIVE_EVENTS',
  HIDE_LIVE_EVENTS: 'HIDE_LIVE_EVENTS',
  IGNORE: 'IGNORE',
}
export const HOME_TEMPLATE = '{team1}'
export const AWAY_TEMPLATE = '{team2}'

export const OPENING_SBID = 'opening'
export const OPENING_BOOK_KEY = `book-${OPENING_SBID}`
export const OPENING_BOOK = {
  sbid: OPENING_SBID,
  isOpener: true,
  nam: 'OPENER',
}

export const oddTypeSP = { VALUE: -1, LABEL: 'SP' }

export const PLACEHOLDERS = 6
